"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Box_1 = __importDefault(require("src/components/Box"));
var useAccordionContext_1 = require("./useAccordionContext");
var helpers_1 = require("./helpers");
var styled_1 = __importDefault(require("./styled"));
var Accordion = function (_a) {
    var children = _a.children, _b = _a.allowMultiple, allowMultiple = _b === void 0 ? false : _b, _c = _a.defaultIndex, defaultIndex = _c === void 0 ? [] : _c, rest = __rest(_a, ["children", "allowMultiple", "defaultIndex"]);
    var _d = (0, react_1.useState)([]), expandItems = _d[0], setExpandItems = _d[1];
    var handleExpandItems = function (_a) {
        var index = _a.index, isExpanded = _a.isExpanded, isDisabled = _a.isDisabled;
        if (isDisabled) {
            return;
        }
        if (isExpanded && allowMultiple) {
            setExpandItems(expandItems.filter(function (itemIndex) { return itemIndex !== index; }));
        }
        else {
            setExpandItems(__spreadArray(__spreadArray([], expandItems, true), [index], false));
        }
        if (!allowMultiple) {
            setExpandItems([index]);
        }
    };
    (0, react_1.useEffect)(function () {
        if (defaultIndex.length) {
            setExpandItems(__spreadArray([], defaultIndex, true));
        }
    }, []);
    var findExpanded = (0, react_1.useCallback)(function (index) {
        if (!expandItems || expandItems.length === 0) {
            return false;
        }
        if (allowMultiple) {
            return expandItems.includes(index);
        }
        return expandItems[0] === index;
    }, [expandItems]);
    var renderIcon = function (_a) {
        var isExpanded = _a.isExpanded, icon = _a.icon;
        if (typeof icon === 'boolean') {
            return react_1.default.createElement(styled_1.default.Icon, { expanded: !isExpanded, color: { light: 'gray900', dark: 'gray200' } });
        }
        if (react_1.default.isValidElement(icon)) {
            return icon;
        }
        if ((0, helpers_1.isObject)(icon)) {
            return isExpanded ? icon.open : icon.close;
        }
        return null;
    };
    var updateChildrenWithProps = react_1.default.Children.map(children, function (child, i) { return react_1.default.cloneElement(child, {
        index: i,
    }); });
    return (react_1.default.createElement(useAccordionContext_1.AccordionProvider, { value: { handleExpandItems: handleExpandItems, expandItems: expandItems, allowMultiple: allowMultiple, findExpanded: findExpanded, renderIcon: renderIcon } },
        react_1.default.createElement("div", { id: "accordion" },
            react_1.default.createElement(Box_1.default, __assign({ column: true }, rest), updateChildrenWithProps))));
};
exports.default = Accordion;
